import { Ajax } from '@shared/Ajax';


function entityMapper(old: IScreenshotOld): IMapPageState {
    return {
        projectId: null,
        liveState: false,
        page: 'MAP3D_LEGACY',
        type: '3D',
        visibility: 'PUBLIC',
        folderId: kuura.getRootFolderId(),
        dataVersion: 1,

        name: old.info.name,
        thumbnail: old.img.src,
        id: old.id,
        uuid: old.id + '',
        timestamp: old.info.date,
        username: old.info.username,

        data: {
            activeAlignmentsId: null,
            map: {
                clickMarker: null,
                tileLayerId: old.backgroundMapLayer === 2 ? 8 : old.backgroundMapLayer,
            },
            panel: {
                activePanel: null,
                models: {
                    fileIds: Array.isArray(old.modelId) ? old.modelId.map(m => m.node.id) : [],
                    fileNames: Array.isArray(old.modelId) ? old.modelId.map(m => m.node.name) : [],
                    headUuids: Array.isArray(old.modelId) ? old.modelId.map(m => m.node.headUuid) : [],
                },
                bgMaps: {
                    headUuids: old.mapIds,
                    fileIds: old.mapIds,
                    fileNames: old.mapIds,
                    rasterizedModelId: null,
                },
            },
            featureCounts: {
                models: Array.isArray(old.modelId) ? old.modelId.length : 0,
                bgMaps: old.mapIds.length,
                logpoints: 0,
                images: 0,
                documents: 0,
            },
            map3d: {
                capabilities: old.capabilities,
                clippingPlane: old.clippingPlane,
                height: old.height,
                offset: old.offset,
                offsetTranslation: old.offsetTranslation,
                position: old.position,
                rotation: {
                    x: old.rotation._x,
                    y: old.rotation._y,
                    z: old.rotation._z,
                    order: old.rotationOrder || old.rotation._order || 'targetSystem'
                }
            }
        }
    };
}

function fetchAll() {
    return Ajax({
        url: 'visualization/screenshots.json',
    }).then(resp => {
        return resp.items.map(entityMapper);
    });
}

function remove(id: number) {
    return Ajax({
        url: 'visualization/screenshot/delete.json',
        method: 'POST',
        data: {
            id
        }
    });
}

export const LegacyStateService = {
    fetchAll,
    remove,
    entityMapper
};
